import React, { Component } from 'react'
import { connect } from 'react-redux'
import { languageSwitchItem } from '../actions/locales'
import i18next from 'i18next'
import { createSession, sendInputData, sendSessionOption, deleteSession, createTS, getTSResult, getTSStatus, sendTSData, verifyTSData, verifyTSResult } from '../actions/api'
import { setFileForTs, clearFileForTs, setFileWithTsForDownload, clearFileWithTsForDownload, setFileInput, clearFileInput, setFileWithTs, clearFileWithTs } from '../actions/localStates'
import { bindActionCreators } from 'redux';

class CreateVerifyTSContainer extends Component {

	constructor(props) {
    super(props);

	    this.state = {
			createIsLoading: false,
			verifyIsLoading: false,
			uuid: null,
			downloadIsAvailable: true
		}
	}

	buildFileForTSSelector(){
		const fileForTS = document.getElementById('fileForTSUpload');
		return fileForTS;
	}

	buildFileInputSelector(){
		const fileInput = document.getElementById('fileInputUpload');
		return fileInput;
	}

	buildFileWithTSSelector(){
		const fileWithTS = document.getElementById('fileWithTSUpload');
		return fileWithTS;
	}

	componentDidMount(){
    	this.fileForTS = this.buildFileForTSSelector();
    	this.fileInput = this.buildFileInputSelector();
    	this.fileWithTS = this.buildFileWithTSSelector();
	}

	handleFileForTS(e) {
	    e.preventDefault();
	    this.fileForTS.value = null;
	    this.fileForTS.click()
	    document.activeElement.blur()
	}

	handleFileInput(e) {
	    e.preventDefault();
	    this.fileInput.value = null;
	    this.fileInput.click()
	    document.activeElement.blur()
	}

	handleFileWithTS(e) {
	    e.preventDefault();
	    this.fileWithTS.value = null;
	    this.fileWithTS.click()
	    document.activeElement.blur()
	}

	onChangeFileForTS(e) {
		if (e.target.files[0] !== undefined && (e.target.files[0].size < 104857600)) {
			this.props.actions.setFileForTs(e.target.files[0])
			this.props.actions.clearFileWithTsForDownload()
		}
	}

	onChangeFileInput(e) {
		if (e.target.files[0] !== undefined && (e.target.files[0].size < 104857600)) {
			this.props.actions.setFileInput(e.target.files[0])
		}
	}

	onChangeFileWithTS(e) {
		if (e.target.files[0] !== undefined && (e.target.files[0].size < 104857600)) {
			this.props.actions.setFileWithTs(e.target.files[0])
		}
	}

	cleanUpFileForTS() {
		this.props.actions.clearFileForTs()
		this.props.actions.clearFileWithTsForDownload()
	}

	cleanUpFileInput() {
		this.props.actions.clearFileInput()
	}

	cleanUpFileWithTS() {
		this.props.actions.clearFileWithTs()
	}

	cleanUpForm() {
		this.cleanUpFileForTS()
	}

	cleanUpVerifyForm() {
		this.props.actions.clearFileInput()
		this.props.actions.clearFileWithTs()
	}

	getBlobData() {
		var _this = this
	    var saveBlob = (function () {
	        var a = document.createElement("a");
	        document.body.appendChild(a);
	        a.style.cssText = "display: none";
	        return function (blob, fileName) {
	        	if (navigator.appVersion.toString().indexOf('.NET') > 0) {
		           window.navigator.msSaveBlob(blob, fileName);
		        } else {
		           var url = window.URL.createObjectURL(blob);
		            a.href = url;
		            a.download = fileName;
		            a.click();
		            window.URL.revokeObjectURL(url);     
		        } 
		        window.setTimeout(function () {
			    	_this.setState({downloadIsAvailable: true})
			    }, 1000) 
	        };
	    }());

	    this.setState({downloadIsAvailable: false})
	    saveBlob(this.props.defaultTSState.fileWithTSForDownload, this.props.defaultTSState.fileForTSName + ".ts");
	}

	verifyTS () {
		this.setState({verifyIsLoading: true})
		this.props.actions.createSession(this.props.connectionStatus.baseUrl)
        	.then((response) => {
				this.setState({uuid: response.ticketUuid})
				console.log(response);
			return this.props.actions.sendInputData(this.props.connectionStatus.baseUrl, this.state.uuid, this.props.defaultTSState.fileInput)
				.then(() => this.props.actions.sendTSData(this.props.connectionStatus.baseUrl, this.state.uuid, this.props.defaultTSState.fileWithTS))
				.then(() => this.props.actions.sendSessionOption(this.props.connectionStatus.baseUrl, this.state.uuid, this.props.defaultState))
            	.then(() => this.props.actions.verifyTSData(this.props.connectionStatus.baseUrl, this.state.uuid))
                .then(() => this.props.actions.verifyTSResult(this.props.connectionStatus.baseUrl, this.state.uuid))
                .then((response) => {
                	if (response.failureCause !== undefined && response.failureCause.length > 0) {
                    	console.log(response)
                    	alert(response.failureCause)
            		} else {
            			alert(i18next.t("ts:tsValid": "tsValid"))
            		}
            		this.setState({verifyIsLoading: false})
                })
	            .then(() => this.props.actions.deleteSession(this.props.connectionStatus.baseUrl, this.state.uuid))
        })
    }

	createTS() {
		this.setState({createIsLoading: true})
		this.props.actions.createSession(this.props.connectionStatus.baseUrl)
        	.then((response) => {
				this.setState({uuid: response.ticketUuid})
				console.log(response);
			return this.props.actions.sendInputData(this.props.connectionStatus.baseUrl, this.state.uuid, this.props.defaultTSState.fileForTS)
				.then(() => this.props.actions.sendSessionOption(this.props.connectionStatus.baseUrl, this.state.uuid, this.props.defaultState))
            	.then(() => this.props.actions.createTS(this.props.connectionStatus.baseUrl, this.state.uuid))
	            .then(() => this.props.actions.getTSResult(this.props.connectionStatus.baseUrl, this.state.uuid))
	           	.then((response) => {
	           		if (response !== null) {
            			this.props.actions.setFileWithTsForDownload(response)
            		}
                })
                .then(() => this.props.actions.getTSStatus(this.props.connectionStatus.baseUrl, this.state.uuid))
                .then((response) => {
                	if (response.failureCause !== undefined && response.failureCause.length > 0) {
                    	console.log(response)
                    	alert(response.failureCause)
            		} else {
            			alert(i18next.t("ts:tsSuccessfullyCreated": "tsSuccessfullyCreated"))
            		}
            		this.setState({createIsLoading: false})
                })
	            .then(() => this.props.actions.deleteSession(this.props.connectionStatus.baseUrl, this.state.uuid))
        })
    }

	render() {
		const isEnabled = this.props.defaultTSState.fileForTS && !this.state.createIsLoading
		const verifyIsEnabled = this.props.defaultTSState.fileInput && this.props.defaultTSState.fileWithTS && !this.state.verifyIsLoading
		const downloadEnable = this.props.defaultTSState.fileWithTSForDownload && this.state.downloadIsAvailable
		return (
			<div className="container">
            <div className="row" style={{paddingTop: "10px"}}>
				<div className="col-12">
	                <div className="card">
						<div className="card-header">
							{i18next.t("ts:tsCreatingTitle": "tsCreatingTitle")}
						</div>
	                  	<div className="card-body">
	                        <div className="input-group mb-4">
	                        	<label className="col-5">{i18next.t("ts:dataFileTitle": "dataFileTitle")}</label>
								<input type="text" className="form-control col-6" value={this.props.defaultTSState.fileForTSName} style={{"backgroundColor": "white", "cursor": "pointer"}} onClick={this.handleFileForTS.bind(this)} readOnly />
								{
									this.props.defaultTSState.fileForTS ? <div className="input-group-append">
									      	<button className="input-group-text" style={{"cursor": "pointer"}} onClick={this.handleFileForTS.bind(this)}>{i18next.t("changeFile": "changeFile")}</button>
									      	<button className="input-group-text" style={{"cursor": "pointer"}} onClick={this.cleanUpFileForTS.bind(this)}>{i18next.t("cleanup": "cleanup")}</button>
									    </div> : <div className="input-group-append">
									    	<button className="input-group-text" style={{"cursor": "pointer"}} onClick={this.handleFileForTS.bind(this)}>{i18next.t("chooseFile": "chooseFile")}</button>
									    </div>
								}
								<input id="fileForTSUpload" type="file" onChange={this.onChangeFileForTS.bind(this)} style={{"display": "none"}} />
							</div>
							<button className="btn btn-default" onClick={this.createTS.bind(this)} disabled={!isEnabled}>{i18next.t("ts:createTs": "createTs")}
								{
	                                this.state.createIsLoading ? <span>&nbsp;<i className="fa fa-spinner fa-pulse"></i></span>
	                                : null
	                            }
							</button>
	                        <button className="btn btn-default" style={{marginLeft: "7px"}} disabled={!downloadEnable} onClick={this.getBlobData.bind(this)}>{i18next.t("ts:saveTsToFile": "saveTsToFile")}</button>
	                        <button className="btn btn-default" style={{marginLeft: "7px"}} onClick={this.cleanUpForm.bind(this)}>{i18next.t("cleanUpForm": "cleanUpForm")}</button>
	                    </div>
	                </div>
                </div>
                <div className="col-12" style={{marginTop: "10px"}}>
	                <div className="card">
						<div className="card-header">
							{i18next.t("ts:tsVerifyingTitle": "tsVerifyingTitle")}
						</div>
	                  	<div className="card-body">
	                        <div className="input-group mb-4">
	                        	<label className="col-5">{i18next.t("ts:fileForTsTitle": "fileForTsTitle")}</label>
								<input type="text" className="form-control col-6" value={this.props.defaultTSState.fileInputName} style={{"backgroundColor": "white", "cursor": "pointer"}} onClick={this.handleFileInput.bind(this)} readOnly />
								{
									this.props.defaultTSState.fileInput ? <div className="input-group-append">
									      	<button className="input-group-text" style={{"cursor": "pointer"}} onClick={this.handleFileInput.bind(this)}>{i18next.t("changeFile": "changeFile")}</button>
									      	<button className="input-group-text" style={{"cursor": "pointer"}} onClick={this.cleanUpFileInput.bind(this)}>{i18next.t("cleanup": "cleanup")}</button>
									    </div> : <div className="input-group-append">
									    	<button className="input-group-text" style={{"cursor": "pointer"}} onClick={this.handleFileInput.bind(this)}>{i18next.t("chooseFile": "chooseFile")}</button>
									    </div>
								}
								<input id="fileInputUpload" type="file" onChange={this.onChangeFileInput.bind(this)} style={{"display": "none"}} />
							</div>
							<div className="input-group mb-4">
	                        	<label className="col-5">{i18next.t("ts:tsFileTitle": "tsFileTitle")}</label>
								<input type="text" className="form-control col-6" value={this.props.defaultTSState.fileWithTSName} style={{"backgroundColor": "white", "cursor": "pointer"}} onClick={this.handleFileWithTS.bind(this)} readOnly />
								{
									this.props.defaultTSState.fileWithTS ? <div className="input-group-append">
									      	<button className="input-group-text" style={{"cursor": "pointer"}} onClick={this.handleFileWithTS.bind(this)}>{i18next.t("changeFile": "changeFile")}</button>
									      	<button className="input-group-text" style={{"cursor": "pointer"}} onClick={this.cleanUpFileWithTS.bind(this)}>{i18next.t("cleanup": "cleanup")}</button>
									    </div> : <div className="input-group-append">
									    	<button className="input-group-text" style={{"cursor": "pointer"}} onClick={this.handleFileWithTS.bind(this)}>{i18next.t("chooseFile": "chooseFile")}</button>
									    </div>
								}
								<input id="fileWithTSUpload" type="file" onChange={this.onChangeFileWithTS.bind(this)} style={{"display": "none"}} />
							</div>
							<button className="btn btn-default" onClick={this.verifyTS.bind(this)} disabled={!verifyIsEnabled}>{i18next.t("ts:performFileTs": "performFileTs")}
								{
	                                this.state.verifyIsLoading ? <span>&nbsp;<i className="fa fa-spinner fa-pulse"></i></span>
	                                : null
	                            }
							</button>
	                        <button className="btn btn-default" style={{marginLeft: "7px"}} onClick={this.cleanUpVerifyForm.bind(this)}>{i18next.t("cleanUpForm": "cleanUpForm")}</button>
	                    </div>
	                </div>
                </div>
            </div>
        </div>
		);
	}
}

function mapStateToProps(state) {
    return {
        locales: state.i18n,
        localesReducer: state.localesReducer,
        defaultTSState: state.createVerifyTSReducer,
        defaultState: state.createDSOptionsReducer,
        connectionStatus: state.connectionStatusReucer
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
	    languageSwitchItem,
	    createSession,
	    sendInputData,
	    deleteSession,
	    setFileForTs, 
	    clearFileForTs,
	    setFileWithTsForDownload,
	    clearFileWithTsForDownload,
	    sendSessionOption,
	    createTS,
	    getTSResult,
	    getTSStatus,
	    setFileInput,
	    clearFileInput,
	    setFileWithTs,
	    clearFileWithTs,
	    sendTSData,
	    verifyTSData,
	    verifyTSResult
	};
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateVerifyTSContainer);


// WEBPACK FOOTER //
// ./src/containers/CreateVerifyTSContainer.js